'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002ecollection$002econvert$002e$002dAs$002dJava$002dConverters from "./scala.collection.convert.-As-Java-Converters.js";
import * as $j_scala$002ejdk$002ejavaapi$002e$002dCollection$002dConverters$0024 from "./scala.jdk.javaapi.-Collection-Converters$.js";
var $p;
/** @constructor */
function $c_sc_convert_AsJavaExtensions$SetHasAsJava(outer, s) {
  this.MU = null;
  this.MU = s;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
}
export { $c_sc_convert_AsJavaExtensions$SetHasAsJava as $c_sc_convert_AsJavaExtensions$SetHasAsJava };
$p = $c_sc_convert_AsJavaExtensions$SetHasAsJava.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sc_convert_AsJavaExtensions$SetHasAsJava;
/** @constructor */
function $h_sc_convert_AsJavaExtensions$SetHasAsJava() {
}
export { $h_sc_convert_AsJavaExtensions$SetHasAsJava as $h_sc_convert_AsJavaExtensions$SetHasAsJava };
$h_sc_convert_AsJavaExtensions$SetHasAsJava.prototype = $p;
$p.St = (function() {
  return $j_scala$002ecollection$002econvert$002e$002dAs$002dJava$002dConverters.$f_sc_convert_AsJavaConverters__asJava__sc_Set__ju_Set($j_scala$002ejdk$002ejavaapi$002e$002dCollection$002dConverters$0024.$m_s_jdk_javaapi_CollectionConverters$(), this.MU);
});
var $d_sc_convert_AsJavaExtensions$SetHasAsJava = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sc_convert_AsJavaExtensions$SetHasAsJava, "scala.collection.convert.AsJavaExtensions$SetHasAsJava", ({
  sL: 1
}));
export { $d_sc_convert_AsJavaExtensions$SetHasAsJava as $d_sc_convert_AsJavaExtensions$SetHasAsJava };
